enum MainAreasEnum {
  HOME = 'home',
  /**
   * Area de topo propria, e nao um submenu de Administracao (tarefa 8.3).
   *
   * A fila de alertas e a **primeira tela** que a enfermagem abre no dia -- e a
   * estoria de usuario de `02-alertas.md` diz isso com todas as letras ("assim que
   * entro na plataforma"). Enterra-la dois cliques abaixo contradiz o proposito.
   */
  ALERTS = 'alerts',
  PATIENTS = 'patients',
  APPOINTMENTS = 'appointments',
  REPORTS = 'reports',
  MANAGEMENT = 'management',
}

export default MainAreasEnum;
